import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import DataTable from "react-data-table-component";
import { getReports, getTotalReports } from "../requests/getReports";
import { useTranslation } from "react-i18next";

function ScamReportsTable(_props, ref) {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [totalRows, setTotalRows] = useState(0);
  const { t } = useTranslation();

  // Define the function you want to expose to the parent
  const childFunction = () => {
    console.log("Child function called!");
    fetchData(1, 25);
  };

  // Use useImperativeHandle to expose the function
  useImperativeHandle(ref, () => ({
    childFunction,
  }));

  const fetchData = async (page, perPage) => {
    setLoading(true);
    try {
      const offset = (page - 1) * perPage;
      setData(await getReports(perPage, offset) || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, perPage);
  }, [page, perPage]);

  useEffect(() => {
    (async () => {
      setTotalRows(await getTotalReports());
    })();
  }, []);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const columns = [
    { name: t('pyramid_ponzi'), selector: row => row.scamCompany, sortable: true },
    {
      name: t('invested'), selector: (row) => row.amountInvested,
      cell: (row) => (
        <span className="text-red-600 font-semibold">
          {row.amountInvested.toLocaleString("en-US", { style: "currency", currency: "USD" })}
        </span>
      ),
      sortable: true
    },
    {
      name: t('withdrawn'), selector: (row) => row.amountWithdrawn,
      cell: (row) => (
        <span className="text-green-600 font-semibold">
          {row.amountWithdrawn.toLocaleString("en-US", { style: "currency", currency: "USD" })}
        </span>
      ),
      sortable: true
    },
    { name: t('country_state'), selector: row => row.country === 'Mexico' && row.mexState ? row.mexState : row.country, sortable: true },
    { name: t('date_registry'), selector: row => row.dateOfRegistry, sortable: true },
    {
      name: t('comment_label'),
      cell: row => (
        <div style={{ whiteSpace: 'normal' }}>
          {row.comment}
        </div>
      ),
      wrap: true, // Allow text wrapping
      sortable: false,
      width: '45%'
    },

  ];
  return (

    <DataTable
      title={t('scam_reports')}
      columns={columns}
      data={data}
      progressPending={loading}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePerRowsChange}
      paginationPerPage={perPage}
      paginationRowsPerPageOptions={[25, 50, 100]}
    />
  );
};

export default forwardRef(ScamReportsTable);
